export default function getEquipmentType(id) {
  if (!id || !window.config.nodes) {
    return 'payment_terminal';
  }
  return window.config.nodes[id] ? window.config.nodes[id].type : '';
}
